export const GENERAL_SETTINGS_TABS = {
  ASSISTANT_SETTINGS: "Agent Settings"
};

export const ERROR_TEXTS = {
  DASHBOARD_ID: "Please enter a dashboard id",
  GROUP_IDS: "Please enter a group id",
  GROUP_IDS_NUMBER: "Please enter a single numerical value"
};

export const ASSISTANT_SETTINGS_TAB_SECTIONS = {
  ACCOUNT: "Account",
  CONFIGURATION_ID: "Configuration Id",
  ASSISTANT_NAME: "Agent Name",
  ERROR_RESPONSE_TEXT: "Error Response Text",
  TEST_AGENT: {
    TITLE: "Test Agent",
    HELPER_TEXT: "Test agents are excluded from feature adoption metrics"
  },
  LOOKER: {
    TITLE: "Looker",
    FIELDS: {
      DASHBOARD_ID: "Dashboard ID",
      GROUP_ID: "Group ID",
      SKILLS_DASHBOARDS: "Skills Dashboards"
    }
  }
};

export const PUBLISH_BUTTON = {
  text: "Save Changes"
};

// These names should be corresponding to the names we receive from the backend
export const ASSISTANT_SETTINGS_TAB_FIELDS = {
  accountName: "accountName",
  clientName: "clientName",
  friendlyName: "friendlyName",
  errorResponseText: "errorResponseText",
  accountTimezone: "accountTimezone",
  agentTimezone: "agentTimezone",
  dashboardId: "dashboardId",
  groupIds: "groupIds",
  skillsDashboards: "skillsDashboards",
  isTestAgent: "isTestAgent"
};

// Boolean fields must not be coerced to "" when false — see GeneralSettings.hook.
export const BOOLEAN_SETTINGS_FIELDS = new Set([ASSISTANT_SETTINGS_TAB_FIELDS.isTestAgent]);
